import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { user, token, termsAgreed } = useContext(AuthContext);
    const location = useLocation();

    // Check if user is authenticated (token is present and user object is populated)
    if (!token || !user) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to. This allows us to send them along to that page after they login.
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 약관 미동의 → 동의 페이지로. 모달이 아니라 라우트 가드라 새로고침해도 우회 불가.
    // termsAgreed 가 null(조회 전/실패)이면 통과시킨다 — 조회 실패로 서비스가 잠기는 쪽이 더 위험.
    if (termsAgreed === false && location.pathname !== '/terms-agree') {
        return <Navigate to="/terms-agree" replace />;
    }

    return children;
};

export default ProtectedRoute;
